import { DownloadOutlined } from '@ant-design/icons'
import { Button, type ButtonProps } from 'antd'
import React, { useState } from 'react'
import { AUTH_TOKEN } from '~/utils/constants'

interface SecureFormPostActionButtonProps {
  title: string
  actionUrl: string
  icon?: React.ReactNode
  type?: ButtonProps['type']
}
const SecureFormPostActionButton: React.FC<SecureFormPostActionButtonProps> = ({ title, actionUrl, icon = <DownloadOutlined />, type = 'primary' }) => {
  const [authToken] = useState<string | null>(localStorage.getItem(AUTH_TOKEN))
  // const [csrfToken] = useState(document.querySelector('meta[name="csrf-token"]')?.getAttribute('content'))

  return <form action={actionUrl} method="post">
    <input name="token" value={authToken ?? ''} hidden readOnly />
    <input name="_token" value={authToken ?? ''} hidden readOnly />
    <Button type={type} htmlType="submit" icon={icon}>{title}</Button>
  </form>
}

export default SecureFormPostActionButton
